import Base from './base';

const LANGUAGES = [
	{
		culture: 'nl',
		searches: ['.nl'],
	},

	{
		culture: 'ch',
		searches: ['.ch', '-che'],
	},
];

class TranslationsToggle extends Base {
	constructor(el) {
		super(el);

		const { location: { host } } = window;
		const { culture = null } = LANGUAGES.find(obj => obj.searches.some(search => host.includes(search))) || {};

		this.toggle(culture);
	}

	toggle(culture) {
		if (!culture) {
			return;
		}

		this
			.queryAll('[data-culture]')
			.filter(el => el.dataset.culture !== culture)
			.forEach(el => el.classList.add('is-hidden'));
	}
}

export default TranslationsToggle;
